import Vue from 'vue'
import VerticalSlider from "./components/VerticalSlider";
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'


Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;
window.Vue = Vue;

Vue.component("vertical-slider", VerticalSlider)
new Vue().$mount('#sidebarslider')

